module.exports = __webpack_public_path__ + "img/romantic@2x.e898ffd.jpg";